import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Http } from '@angular/http';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
//import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule, MatInputModule, MatButtonModule, MatSortModule, MatSort, MatDialogModule, MAT_DATE_LOCALE, MatDialogRef,
  MatNativeDateModule, MatDatepickerModule, MatListModule, MatIconModule, MatAutocompleteModule, MAT_DIALOG_DATA } from '@angular/material';
import { LoadingModule } from 'ngx-loading';
import { NgxSpinnerModule } from 'ngx-spinner';
import {MatTreeModule} from '@angular/material/tree';

import { AppComponent } from './app.component';

// import {TreeTableModule} from "ng-treetable"; 

// Custom Providers 
import { ApplicationConstants } from '../providers/application-constants';
import { Utils } from '../providers/utils';
// import { Classes } from '../providers/classes';
//import { Preloader } from '../providers/preloader';
//import { TranslateModule , TranslateStaticLoader, TranslateLoader} from 'ng2-translate/ng2-translate';
// import { TranslateModule , TranslateStaticLoader, TranslateLoader} from 'ng2-translate/ng2-translate';
import { LanguageService } from '../providers/language.service';
import { QueryList } from '../providers/query-list';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

// import { UserMainComponent } from './user-main/user-main.component';

import { AppRoutingModule } from './app-routing.module';

import { AlertComponent } from './_directives';
import { AuthGuard } from './_guards';
import { JwtInterceptor, ErrorInterceptor } from './_helpers';
import { AlertService, AuthenticationService, UserService } from './_services';

import { PreloaderComponent } from './preloader/preloader.component';
import { TravelerComponent } from './traveler/traveler.component';

// import { LoginComponent } from './login/login.component';
// import { UserViewModule } from './user-view.module';
// import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
// import { ItemCatComponent } from './item-cat/item-cat.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AlertComponent,
    PreloaderComponent,
    TravelerComponent
    // LoginComponent,
    // PageNotFoundComponent,
    
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    MatTableModule,
    MatSortModule,
    MatListModule, 
    BrowserAnimationsModule,
    HttpClientModule,
    MatDialogModule,
    FormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatIconModule,
    LoadingModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    // UserViewModule,
    NgxSpinnerModule,
    MatTreeModule,
    // TreeTableModule,
    HttpClientModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    })
    // TranslateModule.forRoot({
    //   provide: TranslateLoader,
    //   useFactory: (createTranslateLoader),
    //   deps: [Http] Classes,
    // })
  ],
  providers: [ApplicationConstants, Utils, LanguageService, QueryList, 
    AuthGuard,
    AlertService,
    AuthenticationService,
    UserService,
    { provide: MatDialogRef, useValue: {} },
	{ provide: MAT_DIALOG_DATA, useValue: [] },
    //Preloader,
    //{ provide: APP_INITIALIZER, useFactory: preloaderFactory, deps: [Preloader], multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },//,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
    //{provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
  ],
  
  entryComponents:[], 
  // ItemCatComponent
  //   SearchEmployeeComponent, SearchSubItemComponent, SearchSupplierComponent, SearchCustomerComponent, 
  //   JournalEntryComponent, SuppInvSearchSubitemComponent, SuppInvPaymentMethodComponent, TransferComponent, DepositComponent, SupplierInvoiceReportComponent,
  //   SupplierInvoiceDetailComponent,
  //   RepAcctComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }

// export function preloaderFactory(provider: Preloader) {
//   return () => provider.load();
// }
